// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JhGn","location":"Header_location__1LeXU"};